import React, { FC, useState } from 'react'

import { Modal, Txt, StandardButton, Icon } from 'src/components/atoms'

import { useError, useIpRestriction, useToast } from 'src/hooks'
import { AllowedIpEntity } from 'src/types'

type Props = {
  allowedIp: AllowedIpEntity
  isOpen: boolean
  isLast: boolean
  onClose: () => void
  afterDelete?: () => void
}

export const DeleteAllowedIpModal: FC<Props> = ({
  allowedIp,
  isOpen,
  isLast,
  onClose,
  afterDelete,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const { deleteAllowedIp, updateIpRestriction } = useIpRestriction()
  const { toErrorEntities } = useError()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnDelete = async () => {
    setIsDeleting(true)

    try {
      await deleteAllowedIp({ allowedIpId: allowedIp.id })
      if (isLast) {
        await updateIpRestriction(false)
      }

      displayStandardTextToast('IPアドレスを削除しました')
      onClose()
      afterDelete && afterDelete()
    } catch (error) {
      const errors = toErrorEntities(error)
      console.log('errors: ', errors)
      displayErrorTextToast('IPアドレスの削除に失敗しました')
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon size="--r1" path="trash/soft/line" className="tw-accent-standardText-secondary" />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              許可IPアドレスから削除
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[37.86rem] tw-p-s2">
        {isLast && (
          <div className="tw-centering tw-mb-s2">
            <Txt>
              削除すると、指定されたIPアドレスからのアクセスが
              <br />
              できなくなります。削除して本当によろしいですか？
            </Txt>
          </div>
        )}
        <div className="tw-centering">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除する"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
